"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GenomicFileFormat;
(function (GenomicFileFormat) {
    GenomicFileFormat[GenomicFileFormat["BigWig"] = 0] = "BigWig";
    GenomicFileFormat[GenomicFileFormat["BigBed"] = 1] = "BigBed";
    GenomicFileFormat[GenomicFileFormat["ValisGenes"] = 2] = "ValisGenes";
    GenomicFileFormat[GenomicFileFormat["ValisDna"] = 3] = "ValisDna";
    GenomicFileFormat[GenomicFileFormat["ValisVariants"] = 4] = "ValisVariants";
})(GenomicFileFormat = exports.GenomicFileFormat || (exports.GenomicFileFormat = {}));
var Formats = /** @class */ (function () {
    function Formats() {
    }
    Formats.determineFormat = function (path) {
        var fileExtension = path.substr(path.lastIndexOf('.') + 1).toLowerCase();
        return this.extensionMap[fileExtension];
    };
    Formats.extensionMap = {
        // BigWig
        'bigwig': GenomicFileFormat.BigWig,
        'bwig': GenomicFileFormat.BigWig,
        'bw': GenomicFileFormat.BigWig,
        // BigBEd
        'bigbed': GenomicFileFormat.BigBed,
        'bbed': GenomicFileFormat.BigBed,
        'bb': GenomicFileFormat.BigBed,
        'vgenes-dir': GenomicFileFormat.ValisGenes,
        'vdna-dir': GenomicFileFormat.ValisDna,
        'vvariants-dir': GenomicFileFormat.ValisVariants,
    };
    return Formats;
}());
exports.Formats = Formats;
